import { render, staticRenderFns } from "./modalForgotPass.vue?vue&type=template&id=6a361f23"
import script from "./modalForgotPass.vue?vue&type=script&lang=js"
export * from "./modalForgotPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports